export default "__VITE_ASSET__Ch0IUtO8__"